/**
 * PWA Service Worker registration utilities
 */

const SW_PATH = '/sw.js';

/**
 * Register Service Worker
 * Only registers in production (not localhost)
 */
export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    console.log('[PWA] Service Worker not supported');
    return false;
  }

  // Skip in development (localhost or any subdomain of localhost)
  const isLocalhost = 
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname.endsWith('.localhost') ||
    window.location.protocol === 'http:' && window.location.port !== ''; // Parcel dev server
  
  if (isLocalhost) {
    console.log('[PWA] Skipping SW registration in development');
    return false;
  }

  try {
    const registration = await navigator.serviceWorker.register(SW_PATH, {
      scope: '/'
    });

    console.log('[PWA] Service Worker registered:', registration.scope);

    // Handle updates
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing;
      
      newWorker.addEventListener('statechange', () => {
        if (newWorker.state === 'installed') {
          if (navigator.serviceWorker.controller) {
            // New update available
            console.log('[PWA] New version available');
            showUpdateNotification(newWorker);
          } else {
            // First install
            console.log('[PWA] Content cached for offline use');
          }
        }
      });
    });

    return registration;
  } catch (error) {
    console.error('[PWA] SW registration failed:', error);
    return false;
  }
}

/**
 * Show update notification
 */
function showUpdateNotification(worker) {
  // Dispatch event that app can listen to
  globalThis[Symbol.for('APP_BUS')].dispatchEvent(
    new CustomEvent('pwa:update', { detail: { worker } })
  );
}

/**
 * Skip waiting and activate new SW
 */
export async function skipWaiting() {
  const registration = await navigator.serviceWorker.getRegistration();
  if (registration && registration.waiting) {
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
  }
}

/**
 * Check if app is installed (standalone mode)
 */
export function isStandalone() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true
  );
}

/**
 * Initialize PWA
 */
export function initPWA() {
  registerServiceWorker();
  
  console.log('[PWA] Initialized, standalone:', isStandalone());
}
